/**
 * @file Library configuration.
 *
 * Consumers call `init()` once before components load.
 * Internal code reads values via the exported `config` object.
 *
 * @example
 * import { init } from "./config";
 * init({ endpoint: "/services/graphql/", language: "en" });
 */

export const config: BpConfig = {
  endpoint: "/services/graphql/",
  language: "en",
  base: undefined,
};

/** @deprecated Will be removed with global-header/footer. */
export const USER_API_URL = "/services/current-user/";

/** @deprecated Will be removed with global-header/footer. */
export const NEWSLETTER_API_URL = "/services/newsletter/";

/**
 * @deprecated Use the `config` object instead. Will be
 * removed in a future major version.
 */
export function get(key: string, fallback?: unknown): unknown {
  if (import.meta.env.DEV) {
    console.warn("[bp] get() is deprecated. Use the config object instead.");
  }

  const map: Record<string, () => unknown> = {
    API_URL: () => config.endpoint,
    LANGUAGE: () => config.language,
    ASSET_BASE_URL: () => config.base,
    USER_API_URL: () => USER_API_URL,
    NEWSLETTER_API_URL: () => NEWSLETTER_API_URL,
    DEBUG: () => undefined,
  };

  return map[key]?.() ?? fallback;
}

/**
 * Initialize library configuration. Merges provided values
 * with current state. Safe to call multiple times.
 */
export function init(options: Partial<BpConfig> = {}) {
  Object.assign(config, options);
}

/**
 * @deprecated Use `init()` instead. Will be removed in a
 * future major version.
 */
export function set(key: string, value: unknown) {
  if (import.meta.env.DEV) {
    console.warn("[bp] set() is deprecated. Use init() instead.");
  }

  const map: Record<string, () => void> = {
    API_URL: () => (config.endpoint = value as string),
    LANGUAGE: () => (config.language = value as string),
    ASSET_BASE_URL: () => (config.base = value as string),
    USER_API_URL: () => {},
    NEWSLETTER_API_URL: () => {},
    DEBUG: () => {},
  };

  map[key]?.();
}
